import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FloatingThreadContainerComponent } from './floating-thread-container.component';
import { ChatModule } from '../chat/chat.module';
import { UiTooltipDirective } from '../../elements/ui-tooltip/ui-tooltip.directive';

@NgModule({
  declarations: [
    FloatingThreadContainerComponent
  ],
  imports: [
    CommonModule,
    ChatModule,
    UiTooltipDirective
  ],
  exports: [
    FloatingThreadContainerComponent
  ]
})
export class FloatingThreadModule { }
